import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Blog } from 'src/app/_models/blog';
import blogsData from '../../../_models/blogs.json';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { L10nTranslationService } from 'angular-l10n';
import { CommonService } from 'src/app/_services/common.service';
import { NguCarousel, NguCarouselConfig } from "@ngu/carousel";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isKsaImg: boolean = true;
  currentLanguage = this.commonService.currentLanguage;
  cellsToShow: number;
  @ViewChild('myCarousel') myCarousel: NguCarousel<any>;
imagePath2 = '../../../../assets/svg/GRC hero En.svg';
  constructor(private cdr: ChangeDetectorRef, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, private L10nTranslationService: L10nTranslationService, public commonService: CommonService,
    private router: Router) { 
      iconRegistry.addSvgIcon(
        "GRCConsulting",
        sanitizer.bypassSecurityTrustResourceUrl("../../../../assets/svg/autonioo.svg")
      );
      iconRegistry.addSvgIcon(
        "ManagedAwareness",
        sanitizer.bypassSecurityTrustResourceUrl("../../../../assets/svg/fingercriclee.svg")
      );
      iconRegistry.addSvgIcon(
        "Certification",
        sanitizer.bypassSecurityTrustResourceUrl("../../../../assets/svg/languagesquaree.svg")
      );
    }

  dynamicTextArray = [this.L10nTranslationService.translate('Automate Enterprise GRC'), this.L10nTranslationService.translate('Automate SAMA Compliance'), this.L10nTranslationService.translate('Automate Cybersecurity GRC'), this.L10nTranslationService.translate('Manage Vendor Risks'), this.L10nTranslationService.translate('Launch Awareness Campaigns'), this.L10nTranslationService.translate('Simulate Phishing Attacks'),this.L10nTranslationService.translate('Reduce Operational Overhead'),this.L10nTranslationService.translate('Pass Audit Quickly')];

  sectionInputCards = [
    {
      title: 'GRC Consulting',
      description: 'We provide full assessment and implementation2',
      imagePath: 'GRCConsulting',
      link: '/services/Consultations'
    },
    {
      title: 'Managed Awareness',
      description: 'We help you with designing and running2',
      imagePath: 'ManagedAwareness',
      link: '/services/Awareness'
    },

    {
      title: 'Certification',
      description: 'We help you achieve compliance certification2',
      imagePath: 'Certification',
      link: '/services/Compliance'
    }]



  header = this.L10nTranslationService.translate('Who We Are');
  description = this.L10nTranslationService.translate('We are a cybersecurity company based in Riyadh specialized in building modern platforms to solve  cybersecurity and enterprise GRC challenges');
  joinChat: boolean = false;
  imagePath = "../../../../assets/images/undraw_mobile_search_jxq5 1.png";
  routerHeroButton = '/about-us';
  buttonHeroText = this.L10nTranslationService.translate('Learn more');

  textDynamic = ''
  textDynamicLength = 0;

  imageText = this.L10nTranslationService.translate("Highly configurable platforms to fit processes and methodologies used in your organization");
  routerLink = "/contact-us";
  imageTextPath = "../../../../assets/images/undraw_mobile_search.png";
  buttonText = this.L10nTranslationService.translate("Request a demo");
  routerButton = "/contact-us";
  imageUrl = '../../../../assets/images/product-background.png';


  arrowsTheme: 'light' | 'dark' = 'dark';
  typeWriterInterval: any
  blogs: Array<Blog> = [];
  nextText = false;
  dynamicTexCurrentIndex = 0;
  ngOnInit(): void {
    for (let i = 0; i < 3; i++) {
      this.blogs.push(blogsData[i]);
    }

    this.setNextItem(this.dynamicTextArray[this.dynamicTexCurrentIndex])

    if (this.commonService.isMobile) {
      this.cellsToShow = 1
    } else {
      this.cellsToShow = 3
    }
        if(this.currentLanguage == 'en'){
      this.imagePath2 = '../../../../assets/images/GRC hero En.png';
    }else{
      this.imagePath2 = '../../../../assets/images/GRC hero Ar.png';
    }

  }

  blogDetailsNavigation(id: number) {
    this.router.navigate(['blogs-details/' + id]);
  }



  clearTypeWriterInterval() {
    clearInterval(this.typeWriterInterval);
    this.textDynamicLength = 0;
    this.textDynamic = ''
    this.dynamicTexCurrentIndex++
    this.setNextItem(this.dynamicTextArray[this.dynamicTexCurrentIndex])
  }
  typeWriter(text: string) {

    if (this.textDynamicLength < text.length) {
      this.nextText = false

      this.textDynamic += text.charAt(this.textDynamicLength);
      this.textDynamicLength++;
    } else {
      clearInterval(this.typeWriterInterval);
      setTimeout(() => {
        this.nextText = true
        this.clearTypeWriterInterval()
      }, 2000)

    }
  }


  setNextItem(text: string) {
    if (this.dynamicTexCurrentIndex === this.dynamicTextArray.length) {
      clearInterval(this.typeWriterInterval);
      this.dynamicTexCurrentIndex = 0
      this.setNextItem(this.dynamicTextArray[this.dynamicTexCurrentIndex])

      return
    }
    this.typeWriterInterval = setInterval(() => {
      this.typeWriter(text)
    }, 50)
  }


  name = 'Angular';
  slideNo = 0;
  withAnim = true;
  resetAnim = true;

  carouselConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    load: 3,
    slide: 1,
    speed: 2000,
    interval: { timing: 3000, initialDelay: 0 },
    loop: true,
    touch: true,
    velocity: 0.2,
    vertical: {
      enabled: true,
      height: 100
    },
    RTL: (this.currentLanguage == 'ar' ? true : false),
  }
  clientsReviewConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    load: 1,
    interval: { timing: 4000, initialDelay: 1000 },
    loop: true,
    touch: true,
    RTL: (this.currentLanguage == 'ar' ? true : false),

  }
  partnersReviewConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 2, lg: 2, all: 0 },
    load: 1,
    interval: { timing: 4000, initialDelay: 1000 },
    loop: true,
    touch: true,
    RTL: (this.currentLanguage == 'ar' ? true : false),

  }
  clientsReview = [
    { msg: 'Solidranges GRC platform has transformed the way we manage our cybersecurity GRC and reduced the operational overheads', position: 'Ali Al Asiri Cybersecurity Head The Communications Space Technology Commission' },
    { msg: 'Solidranges GRC platform has transformed the way we manage our cybersecurity GRC and reduced the operational overheads', position: 'Ali Al Asiri Cybersecurity Head The Communications Space Technology Commission' },
    { msg: 'Solidranges GRC platform has transformed the way we manage our cybersecurity GRC and reduced the operational overheads', position: 'Ali Al Asiri Cybersecurity Head The Communications Space Technology Commission' }

  ]
  partners = [
    '../../../../assets/svg/cst.svg',
    '../../../../assets/images/blomvinst.png',
    '../../../../assets/images/detasad.png',
    '../../../../assets/svg/cst.svg',
    
    '../../../../assets/images/detasad.png',
    '../../../../assets/images/blomvinst.png',
  ]
  carouselItems = [1, 2, 3];


  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  reset() {
    this.myCarousel.reset(!this.resetAnim);
  }

  moveTo(slide: any) {
    this.myCarousel.moveTo(slide, !this.withAnim);
  }

}
